import React from 'react'
import {
  Button,
  Box,
  CircularProgress,
  Snackbar,
  Paper,
  Checkbox,
  FormControlLabel,
} from '@mui/material'
import API from '@aws-amplify/api'
import MuiAlert from '@mui/material/Alert'
import { useDispatch } from 'react-redux'
import { IProduct, TYPE_BARANG_JADI } from 'interfaces/IProduct'

const lastMonth = new Date()
lastMonth.setMonth(lastMonth.getMonth() - 1)

export default function ExportProduct() {
  const [isLoading, setIsLoading] = React.useState<any>(false)
  const [isSuccessSnackbarOpen, setIsSuccessSnackbarOpen] =
    React.useState(false)
  const [isFailureSnackbarOpen, setIsFailureSnackbarOpen] =
    React.useState(false)
  const [alertMessage, setAlertMessage] = React.useState('')
  const [inHouseOnly, setInHouseOnly] = React.useState(false)

  const handleSnackbarClose = (): void => {
    setIsFailureSnackbarOpen(false)
    setIsSuccessSnackbarOpen(false)
  }
  const onExportClick = () => {
    const param = {
      queryStringParameters: {
        pageSize: 9999999,
        inHouseOnly,
        type: TYPE_BARANG_JADI,
      },
    }

    setIsLoading(true)
    let url = `/products/getProduct`
    API.get('products', url, param)
      .then((response) => {
        const rows = [
          [
            'DF',
            'MEREK',
            'KEMASAN',
            'ITEM',
            'UNIT',
            'BERAT/pc',
            'DUS',
            'HALAL',
            'SEGEL',
            'SHRINK',
            'KODE RUAHAN',
            'NOTIF #',
            'EXP',
            'STOK',
            'STATUS',
          ],
        ]
        let counter = 1
        response.forEach((product: IProduct) => {
          let dateString = ''
          if (product.expiry) {
            const date = new Date(product.expiry)
            const options: any = {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }

            dateString = date.toLocaleString('id-ID', options)
          }
          rows.push([
            String(counter++),
            product.brandId,
            product.packagingName,
            product.productName,
            'PCS',
            product.weight ? String(product.weight) : '-',
            product.box ? 'DS' : '',
            product.halal ? 'HL' : '',
            product.seal ? 'SG' : '',
            product.wrap ? 'SH' : '',
            `${[product.premixId, product.packagingId, product.labelId]
              .filter((data) => data)
              .join('.')}`,
            product.notificationNumber,
            dateString,
            String(product.inventory),
            product.productStatus,
          ])
        })

        let csvContent = rows.map((e) => e.join('\t')).join('\n')
        const a = document.createElement('a')
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        const url = window.URL.createObjectURL(blob)
        a.href = url
        a.download = 'product.csv'
        a.style.visibility = 'hidden'
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
      })
      .catch((error) => {
        setAlertMessage('Gagal export data.')
        setIsFailureSnackbarOpen(true)
        // Error exporting product
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const dispatch = useDispatch()
  React.useEffect(() => {
    dispatch({ type: 'SET_PAGE_TITLE', payload: 'Export Product' })
  }, [dispatch])

  return (
    <Box>
      <Paper>
        <Box p={2} mt={1}>
          <Button variant="contained" color="primary" onClick={onExportClick}>
            Export
          </Button>
          <Box display="inline" ml={2} />
          <FormControlLabel
            control={
              <Checkbox
                checked={inHouseOnly}
                onChange={(e) => setInHouseOnly(e.target.checked)}
                inputProps={{ 'aria-label': 'In-House Only' }}
              />
            }
            label="In-House Only"
          />
        </Box>
      </Paper>
      <Snackbar
        open={isSuccessSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="success" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
      <Snackbar
        open={isFailureSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="error" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
      {isLoading && (
        <Box p={3}>
          <CircularProgress />
        </Box>
      )}
    </Box>
  )
}
